import { useEffect, useState } from "react";
import { getFieldLabel } from "../i18n/fieldMapping";

// Zentrale Behandlung „Sitzung abgelaufen“ (Partner-, Fahrer- und Admin-Bereich):
// Die API-Schicht (api.js) meldet abgelaufene Sitzungen per Ereignis; hier wird statt einzelner Fehlermeldungen
// („Daten konnten nicht geladen werden“) eine klare Hinweisseite mit Weg zur Anmeldung angezeigt.
const EVENT = "gt24-session-expired";
const PUBLIC_PATHS = ["/login", "/register", "/2fa-login", "/2fa-setup", "/forgot-password", "/reset-password"];
let shown = false;

/** Fehler der API, die „keine/abgelaufene Sitzung“ bedeuten (401 oder typische Meldungen der Server-Routen). */
export function isSessionError(error) {
  const status = error?.response?.status;
  if (status === 401) return true;
  const msg = String(error?.response?.data?.error || "");
  return /tenant_id|Session|eingeloggt/i.test(msg) && status >= 400;
}

export function notifySessionExpired(requestUrl = "") {
  if (typeof window === "undefined") return false;
  if (shown) return true; // Hinweis steht bereits – weitere fehlgeschlagene Anfragen lösen keine Weiterleitung mehr aus
  // Beim ersten Laden ohne Anmeldung (Sitzungsprüfung) bzw. auf Anmelde-Seiten: normale Weiterleitung statt Hinweis
  if (/\/auth\/session$/.test(String(requestUrl)) || PUBLIC_PATHS.includes(window.location.pathname)) return false;
  shown = true;
  window.dispatchEvent(new Event(EVENT));
  return true;
}

export default function SessionExpiredOverlay() {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const on = () => setOpen(true);
    window.addEventListener(EVENT, on);
    return () => window.removeEventListener(EVENT, on);
  }, []);
  if (!open) return null;
  return (
    <div role="alertdialog" aria-modal="true" aria-labelledby="se-title" style={{
      position: "fixed", inset: 0, zIndex: 100000, background: "rgba(11,20,55,.72)", backdropFilter: "blur(4px)",
      display: "flex", alignItems: "center", justifyContent: "center", padding: 20, fontFamily: "'Inter', system-ui, sans-serif",
    }}>
      <div style={{ background: "#fff", borderRadius: 20, padding: "36px 32px", maxWidth: 420, width: "100%", textAlign: "center", boxShadow: "0 24px 70px rgba(0,0,0,.35)" }}>
        <div style={{ width: 64, height: 64, borderRadius: "50%", background: "#e8eefa", margin: "0 auto 18px", display: "flex", alignItems: "center", justifyContent: "center" }}>
          <svg viewBox="0 0 24 24" width="32" height="32" fill="none" stroke="#2c5cc5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <rect x="4" y="10" width="16" height="11" rx="2" /><path d="M8 10V7a4 4 0 0 1 8 0v3" /><path d="M12 15v2" />
          </svg>
        </div>
        <h2 id="se-title" style={{ fontSize: 22, fontWeight: 800, color: "#111827", margin: "0 0 10px" }}>{getFieldLabel("sessionExpiredTitle")}</h2>
        <p style={{ fontSize: 14.5, color: "#6b7280", lineHeight: 1.6, margin: "0 0 24px" }}>{getFieldLabel("sessionExpiredText")}</p>
        <button type="button" autoFocus onClick={() => { window.location.href = "/login"; }}
          style={{ width: "100%", padding: "14px 20px", border: "none", borderRadius: 12, background: "#2c5cc5", color: "#fff", fontSize: 15, fontWeight: 700, cursor: "pointer" }}>
          {getFieldLabel("sessionExpiredButton")}
        </button>
      </div>
    </div>
  );
}
